import { IWidgetConfiguration } from '../models';

export class SeriesSelectionWidgetConfiguration implements IWidgetConfiguration {
}